import type { ReactNode } from "react";
import { cn } from "../../../..";

interface FormErrorMessageProps {
	variant: "warning" | "danger" | null;
	id?: string;
	className?: string;
	children: ReactNode;
}

export function FormErrorMessage(props: FormErrorMessageProps) {
	const { variant = "danger", id, className, children } = props;

	if (variant === null) {
		return null;
	}

	return (
		<div
			id={id}
			className={cn(
				"mt-1 text-sm",
				{ "text-warning": variant === "warning", "text-danger": variant === "danger" },
				className,
			)}
		>
			{children}
		</div>
	);
}
